var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 0C15.67 0 0 15.67 0 34.9999C0 54.3298 15.67 69.9999 34.9999 69.9999C54.3298 69.9999 69.9999 54.3298 69.9999 34.9999C69.9793 15.6787 54.3213 0.0206543 34.9999 0ZM54.2674 24.2675L29.2674 49.2675C28.2911 50.2435 26.7086 50.2435 25.7325 49.2675L15.7324 39.2675C14.7392 38.3083 14.7117 36.7257 15.6709 35.7325C16.6301 34.7393 18.2127 34.7118 19.2058 35.671C19.2266 35.6912 19.2472 35.7115 19.2674 35.7325L27.4999 43.9651L50.7325 20.7325C51.7256 19.7733 53.3083 19.8009 54.2674 20.7939C55.2032 21.7627 55.2032 23.2986 54.2674 24.2675Z",
    fill: "#38CA60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessCheck);
export default __webpack_public_path__ + "static/media/icon-success-check.ab89fb8eca396dc731b19d3b9e8f3978.svg";
export { ForwardRef as ReactComponent };